import * as types from './checklistItem.types';
import * as constants from './checklistItem.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const checklistItemReducer = generateResourceReducer<types.IChecklistItem>({
  STORE: constants.STORE_CHECKLISTITEM,
  CLEAR: constants.CLEAR_CHECKLISTITEM,
});
